import DisplayCard from './displayCard.js';
export default DisplayCard;
